module.exports = __webpack_public_path__ + "img/scanCode.53564c10.png";